import { EventType } from "./types-and-interfaces/logging-types-constants";
import { useEventDescriptions } from "./useEventDescriptions";
import { tealiumClient } from "../clients/tealiumClient";

const testMode = false; /* DEVNOTE set this true for testing, so it logs info into console */

export const useLogger = () => {
	const { publish } = tealiumClient();
	const { EVENT_DESCRIPTIONS } = useEventDescriptions();

	// EXPORTS

	const logEvent = <T>(eventType: EventType, eventParams: T) => {
		const mapItem = EVENT_DESCRIPTIONS.get(eventType);

		const eventName = mapItem?.postedEventName || eventType;

		let params: any = {
			tealium_event: eventName,
		};

		if (mapItem.customProperties) {
			const customParams = mapItem.customProperties(eventParams);
			Object.assign(params, customParams);
		}

		params = Array.from(Object.keys(params))
			.sort((a, b) => (a === "tealium_event" ? -1 : b === "tealium_event" ? 1 : a.localeCompare(b)))
			.reduce((obj, key) => {
				if (
					params[key] ||
					(params[key] as unknown as boolean) === false ||
					(params[key] as unknown as number) === 0
				) {
					obj[key] = params[key].toString();
				}
				return obj;
			}, {} as any);

		publish(eventName, params, testMode);
	};

	return { logEvent };
};
